export const SWITCHBOARD_ETHEREUM_MAINNET_CONFIG = {
    chain: "ethereum",
    chainId: 1,
    networkName: "Mainnet",
    address: "",
    sbPushOracle: "",
    metadata: {
        defaultRpcUrl: "https://ethereum.publicnode.com",
        defaultExplorer: "https://etherscan.io",
    },
    queues: [],
    attestationQueues: [
        {
            name: "SwitchboardLabs Attestation Queue",
            address: "",
        },
    ],
};
export const SWITCHBOARD_ETHEREUM_TESTNET_CONFIG = {
    chain: "ethereum",
    chainId: 5,
    networkName: "Goerli",
    address: "",
    sbPushOracle: "",
    metadata: {
        defaultRpcUrl: "https://ethereum-goerli.publicnode.com",
        defaultExplorer: "https://goerli.etherscan.io",
    },
    queues: [],
    attestationQueues: [
        {
            name: "SwitchboardLabs Attestation Queue",
            address: "",
        },
    ],
};
/**
@defaultValue the default Aurora configuration

```json
{
  "mainnet": {
    "chain": "ethereum",
    "chainId": 1,
    "networkName": "Mainnet",
    "address": "",
    "sbPushOracle": "",
    "metadata": {
      "defaultRpcUrl": "https://ethereum.publicnode.com",
      "defaultExplorer": "https://etherscan.io"
    },
    "queues": [],
    "attestationQueues": [
      {
        "name": "SwitchboardLabs Attestation Queue",
        "address": ""
      }
    ]
  },
  "testnet": {
    "chain": "ethereum",
    "chainId": 5,
    "networkName": "Goerli",
    "address": "",
    "sbPushOracle": "",
    "metadata": {
      "defaultRpcUrl": "https://ethereum-goerli.publicnode.com",
      "defaultExplorer": "https://goerli.etherscan.io"
    },
    "queues": [],
    "attestationQueues": [
      {
        "name": "SwitchboardLabs Attestation Queue",
        "address": ""
      }
    ]
  }
}
```
 */
export const SWITCHBOARD_ETHEREUM_CONFIG = {
    mainnet: SWITCHBOARD_ETHEREUM_MAINNET_CONFIG,
    testnet: SWITCHBOARD_ETHEREUM_TESTNET_CONFIG,
};
//# sourceMappingURL=data:application/json;base64,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